import { render, staticRenderFns } from "./architecture.vue?vue&type=template&id=2b999138&scoped=true&"
import script from "./architecture.vue?vue&type=script&lang=js&"
export * from "./architecture.vue?vue&type=script&lang=js&"
import style0 from "./architecture.vue?vue&type=style&index=0&id=2b999138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b999138",
  null
  
)

export default component.exports